module.exports = __webpack_public_path__ + "static/media/sports_29.c096aef2.jpg";